import { createAction, props } from '@ngrx/store';
import { EditFlightResponseMapped } from '@shared/services/flight/_interfaces_/booked-flight.mapped.interface';

export const SET_SEARCH_DATA = '[search data] Set search data from retrived flight';

export const setSearchData = createAction(SET_SEARCH_DATA, props<{ data: EditFlightResponseMapped }>());
